import SInput from 'components/opinionless/SInput'
import SInputLabel from 'components/opinionless/SInputLabel'
import { SStyled } from '../styles/theme'
import SText from 'components/opinionless/SText'
import SFlex from 'components/opinionless/SFlex'

export const StyledSFlex = SStyled(SFlex)`
    ${(p) => `
        @media screen and (max-width: ${p.theme.breakpoints[1]}) {
          flex-direction: column;
        }
    `}
`

export const StyledSInputLabel = SStyled(SInputLabel)`
${(p) => `
    @media screen and (max-width: ${p.theme.breakpoints[0]}) {
      margin-top: 10px;
      font-size: 16px;
    }
`}
`

export const StyledSInput = SStyled(SInput)`
${(p) => `
    @media screen and (max-width: ${p.theme.breakpoints[0]}) {
      font-size: 16px;
      padding-top: 9px;
      padding-bottom:9px;
    }
`}
`

export const StyledSTextButton = SStyled(SText)`
${(p) => `
    @media screen and (max-width: ${p.theme.breakpoints[0]}) {
      font-size: 20px;
    }
`}
`
